export default "__VITE_ASSET__CT5cnl5n__"